import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Sparkles, Download, Users, BookOpen } from "lucide-react";

export default function HeroSection({ apostleName = "Apostle Dayna Milam", profileName, showElishaBadge, onInstallClick }) {
  const HERO_IMG = "https://customer-assets.emergentagent.com/job_033adeb0-4821-466d-a137-c74b40513737/artifacts/wc7uyrnx_FirstFruitsAdar2026-80.jpg";

  return (
    <section data-testid="hero-section" className="relative min-h-[90vh] flex items-center bg-navy overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-1000" style={{ backgroundImage: `url(${HERO_IMG})` }}>
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/70 backdrop-blur-[2px]" />
      </div>

      <div className="relative z-10 w-full container-page py-20 sm:py-32">
        <div className="max-w-3xl">
          <div className="flex flex-wrap items-center gap-4 mb-8">
            {showElishaBadge && (
              <Link to="/media?tab=elisha-times" className="inline-block transition-all hover:-translate-y-0.5">
                <Badge className="bg-gold text-navy hover:bg-gold/90 border-transparent shadow-[0_0_15px_rgba(212,175,55,0.4)] inline-flex items-center px-3 py-1 rounded-full font-bold uppercase tracking-wider text-[10px] sm:text-xs">
                  <Sparkles className="h-3.5 w-3.5 mr-1.5" />
                  NEW! Elisha Times
                </Badge>
              </Link>
            )}
            {profileName && (
              <p className="text-gold text-xs font-medium uppercase tracking-widest" data-testid="welcome-greeting">
                Welcome back, {profileName}
              </p>
            )}
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl text-bone leading-[1.1] mb-6 drop-shadow-md">
            One Unified Body. <br className="hidden sm:block" />
            <span className="text-gold">One Digital House.</span>
          </h1>

          <div className="w-16 h-1 bg-gold rounded-full mb-8 opacity-80" />

          <p className="text-bone/90 text-lg sm:text-xl font-medium leading-relaxed mb-6">
            Welcome to the official app for Word Alive Global Center under the headship of {apostleName}.
          </p>

          <p className="text-bone/70 text-base sm:text-lg leading-relaxed mb-12 max-w-2xl">
            This is our digital sanctuary — built to strengthen traditional values of community and accountability. Here, you will find daily spiritual nourishment, tools for discipleship, and direct connection to your home-based Collective.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-6">
            <Button
              data-testid="hero-install-btn"
              className="bg-gold text-navy hover:bg-gold/90 shadow-[0_0_15px_rgba(212,175,55,0.3)] hover:shadow-[0_0_25px_rgba(212,175,55,0.5)] transition-all duration-300 hover:-translate-y-1 rounded-full px-8 py-6 font-bold uppercase tracking-wider text-sm w-full sm:w-auto"
              onClick={onInstallClick}
            >
              <Download className="h-4 w-4 mr-2" /> Install App
            </Button>
            
            <Link to="/media" className="w-full sm:w-auto">
              <Button data-testid="hero-media-btn" variant="outline" className="w-full sm:w-auto bg-navy/30 backdrop-blur-md border-gold/40 text-gold hover:bg-navy/50 hover:border-gold shadow-sm transition-all duration-300 hover:-translate-y-1 rounded-full px-8 py-6 font-bold uppercase tracking-wider text-sm">
                <BookOpen className="h-4 w-4 mr-2" /> Daily Bible
              </Button>
            </Link>

            <Link to="/collectives" className="w-full sm:w-auto">
              <Button data-testid="hero-collectives-btn" variant="ghost" className="w-full sm:w-auto text-bone hover:text-gold hover:bg-white/5 transition-all duration-300 rounded-full px-8 py-6 font-bold uppercase tracking-wider text-sm group">
                <Users className="h-4 w-4 mr-2 text-gold group-hover:scale-110 transition-transform" /> Join a Collective
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
